import food from "../../../assets/food.jpg";
import crypto from "../../../assets/crypto.jpg";
import movie from "../../../assets/movie2.jpg";
import dnn from "../../../assets/dnn.png"
import valowiki from "../../../assets/valowiki.png"
import reduxcart from "../../../assets/reduxCart.png"
import iconJs from "../../../assets/icons8-javascript.svg"
import iconReact from "../../../assets/icons8-react.svg";
import iconCss from "../../../assets/icons8-css.svg"
import iconApi from "../../../assets/icons8-api-30.png"
import iconNode from "../../../assets/icons8-nodejs.svg"
import iconExpress from "../../../assets/icons8-express-js.svg"
import iconMongo from "../../../assets/icons8-mongodb.svg"
import iconBootstrap from "../../../assets/icons8-bootstrap.svg"
import iconChakra from "../../../assets/icons8-chakra-ui.svg"
import iconPython from "../../../assets/icons8-python.svg"
import iconMl from "../../../assets/icons8-machine-learning-48.png"
import iconRedux from "../../../assets/icons8-redux-32.png"


export const AboutProjects = [
    {
      projectName: "Cravenow",
      projectGit: "https://github.com/himanshugoldy/CreaveNow-FoodDelivery",
      projectLive: "https://drive.google.com/drive/folders/1NZoqVR3xltCkgKy7FERqOkOCHqxDs1lR?usp=sharing",
      projectImg: food,
      projectIcons: [iconJs, iconReact,iconNode,iconExpress,iconMongo,iconBootstrap],
      projectDesc: "CraveNow is a feature-rich full-stack food delivery application that offers intuitive menu browsing, order management, and order history viewing, while ensuring security and responsiveness."
    },{
      projectName: "ValoWiki",
      projectGit: "https://github.com/himanshugoldy/valowiki",
      projectLive: "https://valoguide.netlify.app/",
      projectImg:valowiki,
      projectIcons:[iconJs,iconReact,iconChakra,iconApi],
      projectDesc:"Discover ValoWiki: Explore agents, competitive tiers, game modes, maps, weapons, player cards, and gun buddies. Enjoy responsive design for seamless access on all devices. Your ultimate Valorant resource awaits."
    },
    {
      projectName: "XCrypto",
      projectGit: "https://github.com/himanshugoldy/CryptoApp",
      projectLive: "https://cryptoappgold.netlify.app/",
      projectImg: crypto,
      projectIcons: [iconJs, iconReact, iconChakra,iconApi],
      projectDesc: "Presented user-friendly platforms for coin exchange, featuring informative graphs. Delivered real-time coin price tracking across time periods, complete with multi-currency insights (Indian Rupee, Dollar, Euro), enhancing user experience."
    },
    {
      projectName: "Movie Scroller",
      projectGit: "https://github.com/himanshugoldy/Movie-Scroller",
      projectLive: "https://moviescroller.netlify.app",
      projectImg: movie,
      projectIcons: [iconJs, iconReact, iconCss, iconApi],
      projectDesc: "Crafted a captivating Netflix-inspired frontend that allows seamless scrolling through the latest movies. Boasting an engaging user interface, it presents an immersive movie exploration experience."
    },
    {
      projectName: "Modulation Classification",
      projectGit: "",
      projectLive: "",
      projectImg: dnn,
      projectIcons: [iconPython,iconMl],
      projectDesc: "My B.tech Project under Prof. Pankaj Verma where we created a smart system using a huge dataset of 1.2 million entries to tell different radio signals apart. System achieved 75.89% accuracy in identifying signals at 0dB signal strength, using carefully designed models."
    },{
      projectName: "Redux Shopping Cart",
      projectGit: "https://github.com/himanshugoldy/basic-redux",
      projectLive: "https://reduxbuythings.netlify.app/",
      projectImg: reduxcart,
      projectIcons: [iconJs,iconReact,iconRedux],
      projectDesc: "Redux Shopping Cart designed to check basic redux and redux toolkit by adding item to the cart and updating price and other things automatically from store."
    }
  ];